import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  {
    prefix: "PARTICIPAR_SORTEIO_",
  }
);

export interface ParticiparSorteioState extends IState {}

const INITIAL_STATE: ParticiparSorteioState = {
  data: {},
  loading: false,
  error: null,
};

const request = (state: ParticiparSorteioState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ParticiparSorteioState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ParticiparSorteioState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const participarSorteio = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ParticiparSorteioTypes = Types;
export const ParticiparSorteioActions = Creators;
